import { NotificationRow } from '@models/notification';
import { atom } from 'jotai';

export const notificationsAtom = atom<NotificationRow[]>([]);
